import * as React from "react";

import {Col, Modal, Row, Select, Tabs} from "antd";
import styles from "./TemplateLinks.module.less";
import FuseSelect, {ISelectedOption, ISelectOption} from "../../components/FuseSelect";
import {IBannerTemplate} from "../../store/banner/template/types";
import {AdLabel, Ads, CampaignWithAds} from "../../store/organizations/types";
import {
    modifyingActiveBannerTemplateAction,
} from "../../store/banner/template/actions";
import {
    ISetActiveCampaignIdsActionPayload,
    ISetActiveOrganizationIdActionPayload, setActiveCampaignIdsAction, setActiveOrganizationIdAction
} from "../../store/organizations/actions";
import remergeCondition from "../../firebase/conditions";
import {AppState} from "../../store";
import {
    selectActiveBannerTemplate,
    selectActiveMasterBannerTemplate
} from "../../store/banner/template/selectors";
import {
    areAdsFetched,
    areCampaignsFetched,
    areOrganizationsFetched, selectAdLabels, selectAdLabelsByActiveCampaignIds, selectVisibleAdsByActiveCampaignIds,
    selectVisibleCampaignOptions, selectVisibleOrganizationsOptions
} from "../../store/organizations/selectors";
import {Dispatch} from "redux";
import {withAuthorization} from "../../firebase/withAuthorization";
import {connect} from "react-redux";
import {SelectValue} from "antd/lib/select";
import {IdObjectsWithId} from "../../utils";
import TemplateDiffs from "./TemplateDiffs";

const {Option, OptGroup} = Select;
const {TabPane} = Tabs;

interface IOwnProps {
    visible: boolean;
}

export interface IOwnDispatchProps {
    onCancel?: () => void
    onLinksChange?: () => void
}

interface IStateProps {
    activeBannerTemplate: IBannerTemplate,
    activeMasterBannerTemplate?: IBannerTemplate,
    areOrganizationsFetched: boolean;
    areCampaignsFetched: boolean;
    organizationsOptions: ISelectOption[];
    campaignsOptions: ISelectOption[];
    campaignsWithAds: IdObjectsWithId<CampaignWithAds>;
    areAdsFetched: boolean;
    adLabels: IdObjectsWithId<AdLabel>;
    visibleLabelIds: string[]
}

interface IDispatchProps {
    modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => void;
    setActiveOrganizationId: (params: ISetActiveOrganizationIdActionPayload) => void
    setActiveCampaignIds: (params: ISetActiveCampaignIdsActionPayload) => void
}

type IProps = IOwnProps & IOwnDispatchProps & IStateProps & IDispatchProps


interface IState {
}

class TemplateLinks extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    handleCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel()
        }
    };

    handleOk = () => {
        if (this.props.onLinksChange) {
            this.props.onLinksChange()
        }
    };

    onOrganizationSelect = (selectedValue: SelectValue, option: ISelectedOption) => {
        let organizationId: string = selectedValue as string;
        this.props.setActiveOrganizationId({organizationId: organizationId});
        this.props.setActiveCampaignIds({campaignIds: []});
        this.props.modifyingActiveBannerTemplate({organizationId: organizationId, campaignIds: [], adLabelIds: []});
    };

    onCampaignChange = (selectedValue: SelectValue) => {
        let campaignIds: string[] = selectedValue as string[];
        this.props.setActiveCampaignIds({campaignIds: campaignIds})
        this.props.modifyingActiveBannerTemplate({campaignIds: campaignIds});
    };

    onAdsChange = (selectedValue: SelectValue) => {
        let adLabelIds: string[] = selectedValue as string[];
        this.props.modifyingActiveBannerTemplate({adLabelIds: adLabelIds})
    };


    render() {
        // console.log("TemplateLinks render........")
        const adsOptions = Object.keys(this.props.campaignsWithAds.byId).map(
            cId => {
                return (
                    <OptGroup label={`[${cId}] ${this.props.campaignsWithAds.byId[cId].name}`} key={cId}>
                        {this.props.campaignsWithAds.byId[cId].ads.map((ad: Ads) => {
                            let adName = `[${ad.id}] [${ad.label_id}]`;
                            if (this.props.adLabels.byId[ad.label_id]) {
                                adName += this.props.adLabels.byId[ad.label_id].name
                            }
                            return <Option key={ad.id}>{adName}</Option>
                        })}
                    </OptGroup>
                )
            }
        )

        const adLabelsOptions = this.props.visibleLabelIds.map(
            id => {
                let adName = `[${id}] `;
                if (this.props.adLabels.byId[id]) {
                    adName += this.props.adLabels.byId[id].name
                }
                return <Option key={id}>{adName}</Option>
            }
        )

        const campaignIdsOptions = this.props.campaignsOptions.map((c: ISelectOption) => (
            <Option key={c.value}>{c.text}</Option>
        ));


        return (
            <Modal
                title={`Link Template`}
                visible={this.props.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                destroyOnClose={true}
                bodyStyle={{height: "80vh"}}
                style={{top: "5vh"}}
                width={"90vw"}
            >
                <Tabs animated={false} size="small">
                    <TabPane tab={"Links"} key={"1"}>
                        <div className={styles.selectSpan}>
                            {this.props.areOrganizationsFetched ?
                                <FuseSelect
                                    placeholder="Type to select Organization..."
                                    options={this.props.organizationsOptions}
                                    defaultValue={this.props.activeBannerTemplate.organizationId}
                                    onSelect={this.onOrganizationSelect}
                                />
                                : this.props.activeBannerTemplate.organizationId
                            }
                        </div>
                        <Row gutter={8}>
                            <Col span={12}>
                                {this.props.areCampaignsFetched ?
                                    <Select
                                        mode="multiple"
                                        placeholder="Select campaigns..."
                                        style={{width: "100%"}}
                                        defaultValue={this.props.activeBannerTemplate.campaignIds}
                                        onChange={this.onCampaignChange}
                                    >
                                        {campaignIdsOptions}
                                    </Select>
                                    : this.props.activeBannerTemplate.campaignIds
                                }
                            </Col>
                            <Col span={12}>
                                {this.props.areCampaignsFetched ?
                                    <Select
                                        mode="multiple"
                                        placeholder="Select ads..."
                                        style={{width: "100%"}}
                                        defaultValue={this.props.activeBannerTemplate.adLabelIds}
                                        onChange={this.onAdsChange}
                                    >
                                        {adLabelsOptions}
                                    </Select>
                                    : this.props.activeBannerTemplate.adLabelIds
                                }
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tab={"Diffs"} key={"2"}>
                        <TemplateDiffs/>
                    </TabPane>
                </Tabs>
            </Modal>
        )
    }
}

const authCondition = (authUser: any) => remergeCondition(authUser);

const mapStateToProps = (state: AppState, props: IOwnProps): IStateProps => ({
    activeBannerTemplate: selectActiveBannerTemplate(state),
    activeMasterBannerTemplate: selectActiveMasterBannerTemplate(state),
    areOrganizationsFetched: areOrganizationsFetched(state),
    areCampaignsFetched: areCampaignsFetched(state),
    campaignsOptions: selectVisibleCampaignOptions(state),
    organizationsOptions: selectVisibleOrganizationsOptions(state),
    campaignsWithAds: selectVisibleAdsByActiveCampaignIds(state),
    areAdsFetched: areAdsFetched(state),
    adLabels: selectAdLabels(state),
    visibleLabelIds: selectAdLabelsByActiveCampaignIds(state),
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {
        modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => dispatch(modifyingActiveBannerTemplateAction({bannerTemplate: value})),
        setActiveOrganizationId: (params: ISetActiveOrganizationIdActionPayload) => dispatch(setActiveOrganizationIdAction(params)),
        setActiveCampaignIds: (params: ISetActiveCampaignIdsActionPayload) => dispatch(setActiveCampaignIdsAction(params)),
    };
};

export default withAuthorization(authCondition)(connect(
    mapStateToProps,
    mapDispatchToProps,
)(TemplateLinks));



